function fixFirefoxAnimation() {
  const main = document.getElementById('main')
  const height = main.offsetHeight
  main.style.height = `${height + 1}px`
  setTimeout(() => {
    main.style.height = `${height - 1}px`
  }, 100)
}

function shouldRunAnimation() {
  return window.innerWidth > 991
}

document.addEventListener('DOMContentLoaded', () => {
  if (shouldRunAnimation()) {
    fixFirefoxAnimation()
  }
})

setTimeout(() => {
  if (shouldRunAnimation()) {
    fixFirefoxAnimation()
  }
}, 1000)
